import React from 'react';
import { Languages } from 'lucide-react';
import { useTrainingLang } from '../i18n/TrainingLangContext';
import { translate } from '../i18n/strings';

/**
 * Full-screen language chooser shown before any training content.
 *
 * Every label is written in its own language and the buttons are sized for a
 * warehouse tablet — a trainee who does not read English must be able to find their
 * own language without help. The heading is repeated in all three languages for the
 * same reason: at this point we do not yet know which one they read.
 */
const LanguageGate = () => {
  const { languages, setLanguage, suggestedLanguage } = useTrainingLang();

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center p-6">
      <Languages className="w-12 h-12 text-amber-500 mb-6" />

      <div className="text-center mb-10 space-y-1">
        {languages.map((l) => (
          <h1
            key={l.code}
            className={l.code === 'en'
              ? 'text-2xl md:text-3xl font-bold text-slate-100'
              : 'text-xl md:text-2xl font-semibold text-slate-300'}
          >
            {translate(l.code, 'gateTitle')}
          </h1>
        ))}
      </div>

      <div className="w-full max-w-md space-y-4">
        {languages.map((l) => (
          <button
            key={l.code}
            type="button"
            onClick={() => setLanguage(l.code)}
            className={`w-full px-6 py-6 rounded-xl text-xl font-semibold transition-colors border-2
              ${l.code === suggestedLanguage
                ? 'bg-amber-600 hover:bg-amber-500 text-white border-amber-400'
                : 'bg-slate-800 hover:bg-slate-700 text-slate-100 border-slate-700'}`}
          >
            <span className="block">{l.nativeLabel}</span>
            {l.nativeLabel !== l.label && (
              <span className="block text-sm font-normal opacity-70 mt-1">{l.label}</span>
            )}
          </button>
        ))}
      </div>

      <p className="mt-8 text-sm text-slate-500 text-center max-w-md">
        {languages.map((l) => translate(l.code, 'changeLanguage')).join(' · ')}
      </p>
    </div>
  );
};

export default LanguageGate;
